<template>
  <img src="~/assets/icon/icon-map.svg" />
</template>
